// This is just an example,
// so you can safely delete all default props below

export default {
    previous_step: 'Tilbake',
    pay_with_vipps_or_card: "Betal med Vipps eller bankkort",
    reserve_with_kolumbus_product: "Reserver med et Kolumbus produkt",
    reserve_free_ferry: "Reserver gratis ferje billett",
    reserve_auto_pass: "Reserver AutoPASS / FerryPay billett",
    reserve_with_kolumbus_travel_money: 'Kolumbuskort (Reisepenger)',
    reserve_with_kolumbus_mobile_ticket: 'Mobil-appen Kolumbus Billett (30-dagers periodebillett)',
    reserve_with_kolumbus_card: 'Kolumbuskort (30-dagers periodebillett)',
    not_available_due_to_vehicle: 'Ikke tilgjengelig på denne ruten med kjøretøy.',
    vehicles: 'Kjøretøy',
    vehicle: 'Kjøretøy',
    make_and_model: 'Merke og modell',
    registration_number: 'Registreringsnummer',
    contact_information: 'Kontaktinformasjon',
    given_name: 'Fornavn',
    family_name: 'Etternavn',
    address_line_1: 'Adresse',
    postal_code: 'Postnr.',
    locality: 'Poststed',
    country_code: 'Land',
    phone_number: 'Mobilnummer: <i>brukes til å sende SMS til deg hvis det er endringer i reisen din. Viktig at du oppgir et mobilnummer du disponerer på reisen.</i>',
    email: 'E‐post: <i>brukes til å motta reisedokumentet og varsle deg om endringer i reisen din, og du trenger det om du ønsker å avbestille reisen din. Viktig at du oppgir en epostadresse du disponerer på reisen.</i>',
    email_repeat: 'Gjenta e-post: <i>dobbeltsjekk at du bruker riktig e-postadresse.</i>',
    pay_with_card: 'Visa / Master Card',
    read_term: 'Jeg har lest og akseptert',
    required_field: 'obligatorisk felt',
    term_purchase: 'Vilkår for billettkjøp',
    term_reservation: "Vilkår for reservasjon",
    term_free_ferry: "Vilkår for gratis ferje",
    term_auto_pass: "Vilkår for AutoPASS / FerryPay",
    checkout_desc: 'Jeg har også sjekket at e-post adressen min er skrevet rett, og at jeg har bestilt til rett reisestrekning, rett antall reisende, rett billettkategori, rett dato og avgangstid.<br />Ved betaling, husk å benytte bankkort som ikke er utgått på gyldighet, det samme gjelder for bankkort tilknyttet Vipps kontoen ved bruk av Vipps.',
    error_vehicle_info: 'Kjøretøy info må oppgis',
    error_vehicle_model: 'Kjøretøy merke og modell type må oppgis (minimum 4 bokstaver/tall)',
    error_vehicle_registration_number: 'Kjøretøy registreringsnummer må oppgis',
    error_given_name: 'Fornavn må oppgis',
    error_family_name: 'Etternavn må oppgis',
    error_address_line_1: 'Adresse må oppgis',
    error_postal_code: 'Postnr. må oppgis',
    error_locality: 'Poststed må oppgis',
    error_country_code: 'Land må oppgis',
    error_phone_number: 'Mobilnummer er ikke gyldig',
    error_email: 'E-post er ikke gyldig',
    error_email_repeat: 'Repetert e-post må være den samme som oppgitt e-post',
    error_agree_term: 'Du har ikke godkjent vilkår for billettkjøp',
    error_sub_selected_payment_method: 'En kolumbus produkt må velges.'
}
